import request from "../../utils/request";
import { Result } from "../../models/general";

// Out-of-bounds clock approvals (RequireApproval policy). One pending item per
// clock side (ClockIn / ClockOut); the enum is string-named over the wire.
export type OutOfBoundsClockType = "ClockIn" | "ClockOut";

// GET api/Shift/OutOfBounds/Pending row — one per pending clock side.
export interface LocationApprovalItem {
  shiftId: number;
  clockType: OutOfBoundsClockType;
  userId: string;
  employeeName: string;
  employeeImageUrl?: string;
  date: string;
  distanceMeters?: number;
  reason?: string;
  submittedOn: string;
}

export async function decideOutOfBoundsApproval(input: {
  shiftId: number;
  clockType: OutOfBoundsClockType;
  isApproved: boolean;
  comment?: string;
}) {
  const response = await request.post<Result<boolean>>(`Shift/OutOfBounds/Decision`, {
    shiftId: input.shiftId,
    clockType: input.clockType,
    isApproved: input.isApproved,
    comment: input.comment,
  });
  return response.data;
}

export async function getPendingOutOfBoundsApprovals() {
  const response = await request.get<Result<LocationApprovalItem[]>>(`Shift/OutOfBounds/Pending`);
  return response.data;
}
